import get from 'lodash/fp/get.js';
import union from 'lodash/union.js';
import toCamelCase from './camelCase';
import { recordStormDoorApiFailure } from './newRelic';

export const mergeRules = (rulesResults) => {
  const rulesResultsObj = toCamelCase(rulesResults);
  const rulesResultsBase = get('0', rulesResultsObj);

  const productRulesData = get('data.data', rulesResultsBase);
  const compatibilityRulesData = get('1.data.data', rulesResultsObj);

  try {
    const mergedRules = {
      ...rulesResultsBase,
      data: {
        ...productRulesData,
        invokedRules: union(
          productRulesData.invokedRules,
          compatibilityRulesData.invokedRules,
        ),
        disabledChoices: union(
          productRulesData.disabledChoices,
          compatibilityRulesData.disabledChoiceIds,
        ),
        messages: union(
          productRulesData.messages,
          compatibilityRulesData.ruleMessages,
        ),
        summaryMessages: union(
          productRulesData.summaryMessages,
          compatibilityRulesData.ruleMessages,
        ),
      },
    };

    return { data: mergedRules };
  } catch (err) {
    recordStormDoorApiFailure('mergeRules', err.status || 500, 'executeRulesApi', rulesResults);
  }

  return Promise.resolve({
    data: {
      optionDetails: [],
      messages: [],
      invokedRules: [],
      disabledOptions: [],
      disabledChoices: [],
      selectedChoices: [],
      summaryMessages: [],
    },
    messages: [],
  });
};
